<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Título</th>
        <th scope="col" class="border-0">Tipo</th>
        <th scope="col" class="border-0">Publicado em</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in magazines" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-magazine-edit', params: { magazineId: row.id }}">{{ row.name }}</d-link>
        </td>
        <td class="td-3">{{ row.type.name ? row.type.name : '' }}</td>
        <td class="td-2">{{ (row.f_published_date) ? row.f_published_date : '' }}</td>
        <td class="td-2">
          <magazine-buttons :magazine="row"></magazine-buttons>
        </td>
      </tr>
      <tr v-if="magazines.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhuma revista cadastrada.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de jogo"
      message="Tem certeza que deseja excluir esse jogo?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import MagazineButtons from './MagazineButtons.vue';
import MagazineDelete from './MagazineDelete';
import { _DELETE_MAGAZINE_ } from './MagazineModel';

export default {
  name: 'magazine-table',
  mixins: [MagazineDelete],
  components: {
    MagazineButtons,
    ConfirmationModal,
  },
  props: {
    magazines: {
      type: Array,
    },
  },
  data() {
    return {
      selectMagazine: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_MAGAZINE_, magazine => {
      this.selectMagazine = magazine.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
